import { useEffect } from 'react';

export function dispatch<T = any>(identifier: string, detail?: T) {
  document.dispatchEvent(new CustomEvent<T>(identifier, { detail }));
}

export function useCustomEventEffect<T = any>(identifier: string, callback?: (event?: CustomEvent<T>) => void) {
  useEffect(() => {
    if (callback) {
      document.addEventListener(identifier, callback);
      return () => {
        document.removeEventListener(identifier, callback);
      };
    }
    return () => {};
  }, [identifier, callback]);

  const effectDispatch = (detail?: T) => {
    dispatch<T>(identifier, detail);
  };

  return { dispatch: effectDispatch };
}
